import clsx from "classnames";
import CTA from "@/ui/CTA";
import classes from "../styles.module.scss";

/**
 * Button group for the highlight box, rendered inside the card or underneath it.
 *
 * @param {Array} [buttons] - Button items.
 * @param {string} [className] - Extra classes for the wrapper.
 * @returns {JSX.Element|null}
 */
export default function HighlightButtons({ buttons = [], className }) {
  if (!buttons.length) return null;

  return (
    <div data-sourceflow-prop="button" className={clsx(classes.highlightBox__buttons, className)}>
      {buttons.map((btn, k) => (
        <CTA
          key={k}
          label={btn.label}
          href={btn.href}
          variant={btn.variant || "tertiary"}
          target={btn.open_in_new_tab ? "_blank" : undefined}
        />
      ))}
    </div>
  );
}
